module.exports = __webpack_public_path__ + "img/vip.c33218b2.png";